import { Navigate } from "react-router-dom";
import { ClassDetail } from "./classDetail/ClassDetail";
import { MapPage } from "./MapPage/MapPage";
import { Messages } from "./messages/Messages";
import { MyClasses } from "./myClasses/MyClasses";
import { Notifications } from "./notifications/Notifications";
import { PaymentPage } from "./PaymentPage/PaymentPage";
import { SearchOnline } from "./searchOnline/SearchOnline";
import { Settings } from "./settings/Settings";
import { ShowMoreDates } from "./showMoreDates/ShowMoreDates";

const basePath = "/user";

const createRoute = (path) => `${basePath}/${path}`;

export const userRoute = {
  index: basePath,
  searchOnline: createRoute("search-online"),
  classDetail: createRoute("class-detail/"),
  showMoreDates: createRoute("show-more-dates/"),
  map: createRoute("map"),
  messages: createRoute("messages"),
  paymentPage: createRoute("payment-page/"),
  myClasses: createRoute("my-classes"),
  settings: createRoute("settings"),
  notifications: createRoute("notifications"),
};

export const userRouter = [
  {
    index: true,
    element: <Navigate to={userRoute.myClasses} replace />,
  },
  {
    path: userRoute.myClasses,
    element: <MyClasses />,
  },
  {
    path: userRoute.classDetail + ":class_id",
    element: <ClassDetail />,
  },
  {
    path: userRoute.showMoreDates + ":class_id",
    element: <ShowMoreDates />,
  },
  {
    path: userRoute.map,
    element: <MapPage />,
  },
  {
    path: userRoute.searchOnline,
    element: <SearchOnline />,
  },
  {
    path: userRoute.messages,
    element: <Messages />,
  },
  {
    path: userRoute.paymentPage + ":class_id",
    element: <PaymentPage />,
  },
  {
    path: userRoute.settings,
    element: <Settings />,
  },

  {
    path: userRoute.notifications,
    element: <Notifications />,
  },
];
